import React, { PropTypes, Component } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";

import { bindActionCreators } from "redux";
import {
	NitroHeading,
	NitroButton,
	NitroPanel,
	NitroText,
	NitroIcon,
	NitroContentNotAvailable,
	NitroLoading
} from "nitro-components";
import styled from "styled-components";
import * as ROUTES from "../../../routes/const";

import {
	NotificationMessage,
	ConfirmDeleteModal,
	NotificationCentreMessage,
	NotificationsSidePanel
} from "../../common/GlobalNotification";

import Breakpoint from "../../../utils/breakpoints";

import Header from "../../../components/layouts/Header";

import NotificationApi from "../../../api/NotificationApi";

import * as globalNotificationActions
	from "../../common/GlobalNotification/actions";

import { throttle, isEmpty } from "lodash";

import { media } from "style-utils";

//import NotificationsSidePanel from "./components/NotificationsSidePanel";

import {
	PAGE_HEADING,
	NO_CONTENT_AVAILABLE_HEADING,
	NO_CONTENT_AVAILABLE_DESCRIPTION,
	DELETE_ALL
} from "./content";

const SourceFilterButton = styled.div`
    position: fixed;
    z-index: 1000;
    left: 50%;
    opacity: 0.95;
    transform: translateX(-50%);
    bottom: ${props => (props.isFooter ? "70px" : "10px")};
    border-radius: 100px;
    transition: all .2s ease-in;
    box-shadow: 0 4px 6px 0 rgba(0,0,0,0.2);
    color: ${props => props.theme.color.secondary};
    background: ${props => props.theme.color.white};
    min-width: 215px;
    text-align: center;
    font-family: ${props => props.theme.font.bold};

    section {
      display: inline-block;
      padding: 8px 5px;
    }
`;

const SectionWithDivider = styled.section`
  border-left: 1px solid #F0F0F0;
`;

const HeaderRightContainer = styled.div`
	float: right;

	>a {
		text-decoration: none;
	}

	>button {
		margin-left: 40px;

	}
`;

const MainContainer = styled.div`
	${media.mobileTablet`
	    margin: 25px 0px;
	    padding: 0px;
  `}
`;

const NotificationContent = styled.div`
	min-height: 500px;
`;

class Notification extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDeleteConfirm: false,
			deleteAll: false,
			isShow: true,
			drilldownOpen: false,
			reportParam: {},
			reportName: "",
			showTable: "allCategoriesTable"
		};
		this.deleteNotification = this.deleteNotification.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);
	}

	componentWillMount() {
		const queryObject = this.getQueryObject();
		const { router } = this.context;

		if (queryObject) {
			this.setState({
				reportParam: queryObject,
				drilldownOpen: true,
				reportName: queryObject.Title
			});
			router.push(ROUTES.NOTIFICATION_CENTER);
		}
	}

	componentDidMount() {
		if (this.props.data && !this.props.data.length > 0) {
			this.props.actions.globalNotificationActions.getNotifications();
		}

		window.addEventListener("scroll", throttle(this.hideBar, 200));
	}
	componentDidUpdate(prevProps) {
		const queryObject = this.getQueryObject();
		const { router } = this.context;

		if (queryObject && prevProps.location.query !== queryObject) {
			this.setState({
				reportParam: queryObject,
				drilldownOpen: true,
				reportName: queryObject.Title
			});

			router.push(ROUTES.NOTIFICATION_CENTER);
		}
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", throttle(this.hideBar, 200));
	}

	getQueryObject = () => {
		const queryObject = this.props.location.query;
		if (!isEmpty(queryObject)) {
			return queryObject;
		}
		return null;
	};

	hideBar = event => {
		if (this.refs.settings) {
			let { isShow } = this.state;
			window.scrollY <= this.prev || window.scrollY <= 0
				? !isShow && this.setState({ isShow: true })
				: isShow && this.setState({ isShow: false });
			this.prev = window.scrollY;
		}
	};

	deleteAll = () => {
		this.setState({
			showDeleteConfirm: true
		});
	};

	closeModal = () => {
		this.setState({
			showDeleteConfirm: false
		});
	};

	goBack = homeRoute => {
		const { router } = this.context;
		router.push(homeRoute);
	};

	viewReport = (reportParam, title) => {
		this.setState(
			{
				drilldownOpen: true,
				reportName: title
			},
			this.context.router.push({
				pathname: `${ROUTES.NOTIFICATION_CENTER}`,
				query: reportParam
			})
		);
	};

	closeDrillDown = () => {
		this.setState({
			drilldownOpen: false,
			showTable: "allCategoriesTable"
		});
	};

	openDrillDown = () => {
		this.setState({
			drilldownOpen: true
		});
	};

	deleteNotification = () => {
		this.props.actions.globalNotificationActions.getNotifications();
	};
	confirmDelete = () => {
		let NotificationKeys = [];
		NotificationKeys = this.props.data.map((item, index, array) => {
			return item.NotificationKeys;
		});

		const NotificationKeysConcat = NotificationKeys.length > 0
			? NotificationKeys.reduce(function(previous, current) {
					return previous.concat(current);
				})
			: [];

		this.props.actions.globalNotificationActions.deleteNotification({
			NotificationIds: NotificationKeysConcat,
			Status: 1 //1-> delete 2-> read
		});
		this.closeModal();
		this.setState = {
			deleteAll: true
		};
	};

	gotoSettings = () => {
		const { router } = this.context;
		router.push(ROUTES.NOTIFICATION_SETTINGS);
	};

	render() {
		const { data, fetchingNotifications, homeRoute } = this.props;
		return (
			<MainContainer>
				<Breakpoint name="desktop">
					<Header>
						<NitroHeading
							header
							inline
							noMargin
							label={PAGE_HEADING}
						/>
						<HeaderRightContainer>
							<Link to={ROUTES.NOTIFICATION_SETTINGS}>
								<NitroIcon
									name="settings"
									size="16"
									right={6}
									variant="base3"
								/>
								<NitroText variant="base3" size="4" bold>
									SETTINGS
								</NitroText>
							</Link>
							{data &&
								data.length > 0 &&
								<NitroButton
									size="compact"
									width="block"
									label={DELETE_ALL}
									leftIcon="delete"
									icon="delete"
									insideIconSize={14}
									action={this.deleteAll}
								/>}
						</HeaderRightContainer>
					</Header>
					<NotificationContent>
						{!fetchingNotifications &&
							!this.state.deleteAll &&
							data &&
							data.map((item, index) => {
								return (
									<NotificationCentreMessage
										title={item.Title}
										categoryName={item.CategoryName}
										description={item.Description}
										timeStamp={item.DaysToolText}
										key={index}
										keys={item.NotificationKeys}
										onDelete={this.deleteNotification}
										reportParam={item.ReportParameters}
										resetConfirm={this.props.deleteComplete}
										onClick={() =>
											this.viewReport(
												item.ReportParameters,
												item.Title
											)}
									/>
								);
							})}
						{(this.state.deleteAll ||
							(data && !data.length && !fetchingNotifications)) &&
							<NitroPanel>
								<NitroContentNotAvailable
									content={NO_CONTENT_AVAILABLE_HEADING}
									description={
										NO_CONTENT_AVAILABLE_DESCRIPTION
									}
									backgroundIndex={1}
								/>
							</NitroPanel>}

						{fetchingNotifications && <NitroLoading />}
					</NotificationContent>
				</Breakpoint>
				<Breakpoint name="mobileTablet">
					<div ref="settings">
						<SourceFilterButton isFooter={this.state.isShow}>
							<section onClick={this.gotoSettings}>
								<NitroIcon
									name="settings"
									size={16}
									variant="secondary"
									right={12}
								/>

								<span>Settings</span>
							</section>
							{data &&
								<SectionWithDivider onClick={this.deleteAll}>

									<NitroIcon
										name="delete"
										size={16}
										variant="secondary"
										right={12}
									/>

									<span>Delete All</span>
								</SectionWithDivider>}
						</SourceFilterButton>
					</div>
					<NitroPanel padding="10px">
						<NotificationContent>
							{!fetchingNotifications &&
								!this.state.deleteAll &&
								data &&
								data.map((item, index) => {
									return (
										<NotificationMessage
											title={item.Title}
											categoryName={item.CategoryName}
											description={item.Description}
											timeStamp={item.DaysToolText}
											key={index}
											keys={item.NotificationKeys}
											onDelete={this.deleteNotification}
											displayDeleteFullWidth
											reportParam={item.ReportParameters}
											onClick={this.viewReport}
											company={item.CompanyName}
										/>
									);
								})}
							{(this.state.deleteAll ||
								(data &&
									!data.length &&
									!fetchingNotifications)) &&
								<NitroPanel>
									<NitroContentNotAvailable
										content={NO_CONTENT_AVAILABLE_HEADING}
										description={
											NO_CONTENT_AVAILABLE_DESCRIPTION
										}
										backgroundImage="noContent"
									/>
								</NitroPanel>}

							{fetchingNotifications && <NitroLoading />}
						</NotificationContent>
					</NitroPanel>

				</Breakpoint>

				<ConfirmDeleteModal
					open={this.state.showDeleteConfirm}
					close={this.closeModal}
					action={this.confirmDelete}
				/>
				<Breakpoint name="tabletDesktop">
					<NotificationsSidePanel
						close={this.closeDrillDown}
						open={this.state.drilldownOpen}
						title={this.state.reportName}
						showTable={this.state.showTable}
						reportParam={this.state.reportParam}
					/>
				</Breakpoint>
				<Breakpoint name="mobile">
					<NotificationsSidePanel
						close={this.closeDrillDown}
						open={this.state.drilldownOpen}
						title={this.state.reportName}
						showTable={this.state.showTable}
						reportParam={this.state.reportParam}
						isMobile
					/>
				</Breakpoint>
			</MainContainer>
		);
	}
}

Notification.propTypes = {
	data: PropTypes.array,
	actions: PropTypes.object.isRequired,
	homeRoute: PropTypes.string,
	fetchingNotifications: PropTypes.bool
};

Notification.contextTypes = {
	router: PropTypes.object,
	location: PropTypes.object
};

const mapStateToProps = state => ({
	data: state.globalNotification.notifications,
	fetchingNotifications: state.globalNotification.fetchingNotifications,
	homeRoute: state.auth.config.homeRoute
});

const mapDispatchToProps = dispatch => ({
	actions: {
		globalNotificationActions: bindActionCreators(
			globalNotificationActions,
			dispatch
		)
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./src/features/notification/notification-center/Notification.js